/// <amd-module name="Pipeline/Analytics/DurationCardMetrics/Sources/DurationCardMetricsSource" />
import { IReportContext } from "Analytics/Shared/Common/Types";
import { ITrendChartData, ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { PipelineDurationCommonSource } from "Pipeline/Analytics/PipelineDurationCommon/Sources/PipelineDurationCommonSource";
import { IMaxDurationTaskData, IPipelineDurationData } from "Pipeline/Analytics/PipelineDurationCommon/Types";
import { IVssPageContext } from "VSS/Platform/Context";

export class DurationCardMetricsSource extends PipelineDurationCommonSource {
    constructor(pageContext: IVssPageContext) {
        super("PipelineAnalytics_InContext_DurationCardMetricsReport", pageContext);
    }

    public getMaxDurationTaskData(reportContext: IReportContext, confValues: ITrendChartReportConfiguration): Promise<IMaxDurationTaskData> {
        return super.getMaxDurationTaskData(reportContext, confValues);
    }

    public queryPipelineDurationData(reportContext: IReportContext, confValues: ITrendChartReportConfiguration): Promise<IPipelineDurationData> {
        return super.queryPipelineDurationData(reportContext, confValues);
    }

    public queryPipelineDurationTrendData(reportContext: IReportContext, confValues: ITrendChartReportConfiguration): Promise<ITrendChartData> {
        return super.queryPipelineDurationTrendData(reportContext, confValues);
    }
}
